const GlobalStyles=
{
    PrimaryButton:
    {
        color:"white",
        backgroundColor:"#0088FF"
    },
    ImageCartaConfiguracion:
    {
        margin:"10px",
        height:"15%",
        cursor:"pointer",
        width:"15%",
        display:"block"
    },
    Icon:
    {
        cursor:"pointer"
    }
}

export default GlobalStyles